import axios from 'axios'
import { toastr } from 'react-redux-toastr'
import { URL } from '../../assets/js/constants'

function negocioProcessing(data) {
    return {
        type: 'NEGOCIO_PROCESSING',
        payload: data
    }
}

export function setarNegocioDoUsuario(negocio) {
    return {
        type: 'NEGOCIO_USUARIO_SETED',
        payload: negocio
    }
}

export function carregarNegocio(data) {
    return {
        type: 'NEGOCIO_FETCHED',
        payload: data
    }
}

export function carregarNegocios(data) {
    return {
        type: 'NEGOCIOS_FETCHED',
        payload: data
    }
}

export function carregarSegmentos(data) {
    return {
        type: 'SEGMENTOS_FETCHED',
        payload: data
    }
}

export function carregarNegocioCadastroFuncionario(data) {
    return {
        type: 'NEGOCIO_CADASTRO_FUNCIONARIO_FETCHED',
        payload: data
    }
}

export function carregarUploadedLogo(data) {
    return {
        type: 'UPLOADED_LOGO',
        payload: data.sort((a, b) => a.id - b.id)
    }
}

function atualizarUploadedLogo(data) {
    return {
        type: 'UPDATE_UPLOADED_LOGO',
        payload: data
    }
}

function deletarUploadedLogo(data) {
    return {
        type: 'DELETED_UPLOAD_LOGO',
        payload: data
    }
}

function negocioLoading(data) {
    return {
        type: 'NEGOCIO_LOADING',
        payload: data
    };
}

function configuracoesLoading(data) {
    return {
        type: 'CONFIGURACOES_LOADING',
        payload: data
    };
}

function carregarConfiguracoesDoNegocio(data) {
    return {
        type: 'CONFIGURACOES_FETCHED',
        payload: data
    };
}

function carregarPlanosAtivos(data) {
    return {
        type: 'PLANOS_ATIVOS_FETCHED',
        payload: data
    }
}

export function getNegocioLogado(usuario) {
    return dispatch => {
        axios.get(`${URL}/negocio/logado/${usuario}`)
            .then(resp => dispatch(carregarNegocio(resp.data)))
            .catch(e => toastr.error('Erro', e.message))
    }
}

export function getNegocio(idNegocio) {
    return dispatch => {
        dispatch(negocioLoading(true));
        axios.get(`${URL}/negocios/MOBILE/completo/${idNegocio}`)
            .then(resp => {
                dispatch(carregarNegocio(resp.data));
                dispatch(negocioLoading(false));
            })
            .catch(e => {
                toastr.error('Erro', e.message)
                dispatch(negocioLoading(false));
            })
    }
}

export function buscarSegmentosAtuacao() {
    return dispatch => {
        axios.get(`${URL}/segmentos/mobile`)
            .then(resp => dispatch(carregarSegmentos(resp.data)))
            .catch(e => toastr.error('Erro', e.message))
    }
}

export function getConfiguracoesDoNegocio(negocioId) {
    return dispatch => {
        dispatch(configuracoesLoading(true));
        axios.get(`${URL}/negocios/configuracoes/${negocioId}`)
            .then(resp => {
                dispatch(carregarConfiguracoesDoNegocio(resp.data));
                dispatch(configuracoesLoading(false));
            })
            .catch(e => {
                try {
                    const data = e.response.data;
                    if (typeof data !== 'undefined') {
                        const { status, msg, errors } = data;
                        if (status === 400) {
                            errors.forEach(erro => {
                                toastr.error(msg, 'Campo: ' + erro.fieldName + '. ' + erro.message);
                            })
                        } else {
                            toastr.error(msg, 'Erro: ' + status);
                        }
                    }
                } catch (e) {
                    return false;
                }
                dispatch(configuracoesLoading(false));
            })
    }
}

export function updateConfiguracoesDoNegocio(data) {
    return dispatch => {
        dispatch(negocioProcessing(true));
        axios.put(`${URL}/negocios/atualizar-configuracoes`, data)
            .then(resp => {
                dispatch(carregarConfiguracoesDoNegocio(resp.data));
                dispatch(negocioProcessing(false));
                toastr.success('Sucesso', 'Configurações atualizadas com sucesso!');
            })
            .catch(e => {
                dispatch(negocioProcessing(false));
                try {
                    const data = e.response.data;
                    if (typeof data !== 'undefined') {
                        const { status, msg, errors } = data;
                        if (status === 400) {
                            errors.forEach(erro => {
                                toastr.error(msg, 'Campo: ' + erro.fieldName + '. ' + erro.message);
                            })
                        } else {
                            toastr.error(msg, 'Erro: ' + status);
                        }
                    }
                } catch (e) {
                    return false;
                }
            })
    }
}

export function getNegocios() {
    return dispatch => {
        dispatch(negocioLoading(true));
        axios.get(`${URL}/negocios/todos-negocios/WEB`)
            .then(resp => {
                dispatch(carregarNegocios(resp.data));
                // 2. Desativa o loading após o sucesso
                dispatch(negocioLoading(false));
            })
            .catch(e => {
                toastr.error('Erro', e.message)
                // 3. Desativa o loading mesmo se houver erro
                dispatch(negocioLoading(false));
            })
    }
}

export function getNegociosAtivos() {
    return dispatch => {
        axios.get(`${URL}/negocios/negocios-ativos`)
            .then(resp => dispatch(carregarNegocios(resp.data)))
            .catch(e => toastr.error('Erro', e.message));
    }
}

export function addNegocio(values) {
    return dispatch => {
        dispatch(negocioProcessing(true));
        axios.post(`${URL}/negocios/novo-negocio`, values)
            .then(_ => {
                dispatch(getNegocios());
                dispatch(negocioProcessing(false));
                toastr.success('Sucesso', 'Negócio cadastrado com sucesso!');
            })
            .catch(e => {
                dispatch(negocioProcessing(false));
                try {
                    const data = e.response.data;
                    if (typeof data !== 'undefined') {
                        const { status, msg, errors } = data;
                        if (status === 400) {
                            errors.forEach(erro => {
                                toastr.error(msg, 'Campo: ' + erro.fieldName + '. ' + erro.message);
                            })
                        } else {
                            toastr.error(msg, 'Erro: ' + status);
                        }
                    }
                } catch (e) {
                    return false;
                }
            })
    }
}

export function buscarNegocioPorCpfOuCnpj(cpfOuCnpj) {
    const cleanCpfOuCnpj = cpfOuCnpj.replace(/\D/g, ''); //Retirar formatação para enviar requisição via http. O servidor está encarregado de refazer a formatação.
    return dispatch => {
        axios.get(`${URL}/negocios/cpf-cnpj/MOBILE/${cleanCpfOuCnpj}`)
            .then(resp => dispatch(carregarNegocioCadastroFuncionario(resp.data)))
            .catch(e => {
                const titulo = e.response?.data?.error || 'Erro inesperado';
                const msg = e.response?.data?.msg || 'Não foi possível pesquisar o CPF/CNPJ. Tente novamente em alguns instantes.';
                toastr.error(titulo, msg);
            });
    };
}


export function updateNegocio(values) {
    return dispatch => {
        dispatch(negocioProcessing(true));
        axios.put(`${URL}/negocios/atualizar-negocio`, values)
            .then(_ => {
                dispatch(getNegocios());
                dispatch(negocioProcessing(false));
                toastr.success('Sucesso', 'Negócio atualizado com sucesso!');
            })
            .catch(e => {
                dispatch(negocioProcessing(false));
                try {
                    const data = e.response.data;
                    if (typeof data !== 'undefined') {
                        const { status, msg, errors } = data;
                        if (status === 400) {
                            errors.forEach(erro => {
                                toastr.error(msg, 'Campo: ' + erro.fieldName + '. ' + erro.message);
                            })
                        } else {
                            toastr.error(msg, 'Erro: ' + status);
                        }
                    }
                } catch (e) {
                    return false;
                }
            })
    }
}

export function desativarNegocio(values) {
    return dispatch => {
        dispatch(negocioProcessing(true));
        axios.put(`${URL}/negocios/desativar-negocio`, values)
            .then(_ => {
                dispatch(getNegocios());
                dispatch(negocioProcessing(false));
                toastr.success('Sucesso', 'Negócio desativado.');
            })
            .catch(e => {
                dispatch(negocioProcessing(false));
                toastr.error('Erro', e);
            }
            )
    }
}

export function captarLeadWeb(values) {
    return axios.post(`${URL}/negocios/captacao-web`, values)
        .then(res => res);
}

export function addImagemLogo(values) {
    let formData = new FormData()
    formData.append('file', values.file);

    return dispatch => {
        axios.post(`${URL}/negocios/${values.id}/logomarca`, formData, {
            headers: {
                'Content-Type': 'multi-part/formdata'
            },
            onUploadProgress: e => {
                const progress = parseInt(Math.round((e.loaded * 100) / e.total));
                const data = { idTemp: values.idTemp, progress };
                dispatch(atualizarUploadedLogo(data));
            }
        })
            .then(resp => {
                const data = resp.data;
                dispatch(atualizarUploadedLogo({ idTemp: values.idTemp, url: data.url, uploaded: true }));
            })
            .catch((e) => {
                dispatch(atualizarUploadedLogo({ idTemp: values.idTemp, error: true }));
            })
    }
}

export function deleteImagemLogo(negocioId) {
    return dispatch => {
        axios.delete(`${URL}/negocios/delete-logomarca/${negocioId}`)
            .then(_ => dispatch(deletarUploadedLogo(negocioId)))
            .then(_ => toastr.success('Sucesso', 'Logotipo excluído.'))
            .catch(e => {
                console.log('deu erro', e);
                toastr.error('Erro', e);
            }
            )
    }
}

export function buscarPlanosAtivos() {
    return dispatch => {
        axios.get(`${URL}/planos/ativos`)
            .then(resp => dispatch(carregarPlanosAtivos(resp.data)))
            .catch(e => toastr.error('Erro', e.message))
    }
}